import React from 'react';

const AdminLogin = () => {
    return (
        <div>
            <h1>admin login page</h1>
        </div>
    );
};

export default AdminLogin;